import React, { useState } from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css" // This only needs to be imported once in your app

import Reveal from "components/utils/Reveal"

import styled from "styled-components"
import SectionStyling from "components/atoms/SectionStyling"
import StandardPadding from "components/atoms/StandardPadding"
import Box from "components/atoms/Box"
import Flex from "components/atoms/Flex"
import FlexGrid from "components/atoms/FlexGrid"
import Button from "components/atoms/Button"
import { Paragraph } from "components/atoms/Typography"

import SectionText from "components/molecules/SectionText"
import CircleLogo from "components/atoms/CircleLogo"
import Markdown from "components/molecules/Markdown"
import LayeredImage from "components/molecules/LayeredImage"
import SocialLinks from "components/molecules/SocialLinks"

import DownArrow from "images/down-arrow.svg"

const StyledDownArrow = styled(DownArrow)`
  transition: opacity 0.2s;
  margin-top: 60px;
  &:hover {
    opacity: 0.7;
  }
`

const StyledImg = styled(Img)`
  border-radius: 100%;
  margin-left: 25%;
`

const LogoWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50%;
`

const ImageText = ({
  sectionStyling,
  sectionText,
  button,
  image,
  imageLocation,
  imageLocationMobile,
  fullWidthImage,
  textUnderImage,
  overlaidImage,
  idx,
  id,
  layeredImage,
  socialLinks,
}) => {
  const [openLightbox, setOpenLightbox] = useState(false)

  const isHero = idx === 0

  const reverse = imageLocation === "left"
  const offsetText = isHero && !image
  const Text = () => (
    <Reveal>
      <Box maxWidth={44} mx="auto" textAlign="center">
        <SectionText {...sectionText} />
        {button && !fullWidthImage && <Button mt={5} {...button} />}
        {socialLinks && (
          <SocialLinks
            lightTheme={sectionStyling.backgroundColor === "white"}
            {...socialLinks}
          />
        )}
      </Box>
    </Reveal>
  )

  let flexDirection = {
    _: imageLocationMobile === "bottom" ? "column" : "column-reverse",
    lg: reverse ? "row-reverse" : "row",
  }

  if (fullWidthImage) {
    flexDirection = { _: "column" }
  }

  return (
    <SectionStyling first={idx === 0} {...sectionStyling}>
      <StandardPadding>
        {offsetText && (
          <Flex py={{ _: 4, sm: 9 }} justifyContent="flex-end">
            <Text />
          </Flex>
        )}
        {!offsetText && (
          <FlexGrid
            gutter={fullWidthImage ? 4 : 8}
            columns={{ _: 1, lg: fullWidthImage ? 1 : image ? 2 : 1 }}
            flexDirection={flexDirection}
            alignItems="center"
            justifyContent={isHero && !image ? "flex-end" : "flex-start"}
          >
            <Text />
            {!layeredImage && image && (
              <Reveal>
                <Box
                  position="relative"
                  style={{ cursor: fullWidthImage ? "pointer" : "auto" }}
                  onClick={() => {
                    setOpenLightbox(true)
                  }}
                >
                  {!overlaidImage && (
                    <Img fluid={image.fluid} alt={image.description} />
                  )}
                  {overlaidImage && (
                    <>
                      <StyledImg fluid={image.fluid} alt={image.description} />
                      <LogoWrapper>
                        <CircleLogo logo={overlaidImage} />
                      </LogoWrapper>
                    </>
                  )}
                  {textUnderImage && (
                    <Paragraph mt={6}>
                      {textUnderImage.textUnderImage}
                    </Paragraph>
                  )}
                </Box>
              </Reveal>
            )}
            {fullWidthImage && openLightbox && (
              <Lightbox
                mainSrc={image.file.url}
                onCloseRequest={() => setOpenLightbox(false)}
              />
            )}
            {layeredImage && <LayeredImage {...layeredImage} />}
          </FlexGrid>
        )}
        {button && fullWidthImage && (
          <Flex justifyContent="center">
            <Button mt={7} {...button} />
          </Flex>
        )}
      </StandardPadding>
    </SectionStyling>
  )
}

export default ImageText

// ImageText.propTypes = {
//   section: PropTypes.shape(Section.strapiProps).isRequired,
//   sectionTitle: PropTypes.shape(SectionTitle.strapiProps).isRequired,
//   text: PropTypes.string,
//   button: PropTypes.shape(Button.strapiProps),
//   image: PropTypes.object,
//   imageLocation: PropTypes.oneOf(["right", "left"]),
// }

export const query = graphql`
  fragment ImageText on ContentfulImageText {
    sectionStyling {
      ...SectionStyling
    }
    sectionText {
      ...SectionText
    }
    button {
      ...Button
    }
    image {
      description
      file {
        url
      }
      fluid(maxWidth: 1200, quality: 90) {
        ...GatsbyContentfulFluid_withWebp
      }
    }
    imageLocation
    imageLocationMobile
    fullWidthImage
    textUnderImage {
      textUnderImage
    }
    layeredImage {
      ...LayeredImage
    }
    socialLinks {
      ...SocialLinks
    }
  }
`
